export interface FilterStatus {
  statuses: number[];
  type: number;
}

export interface FilterPriority {
  priorities: number[];
  type: number;
}

export interface FilterAssign {
  assignees: string[];
  type: number;
}

export interface FilterDueDate {
  date: string[];
  type: number;
}

export interface FilterProject {
  projects: string[];
  type: number;
}

export interface ViewFilters {
  status: FilterStatus;
  priority: FilterPriority;
  assign: FilterAssign;
  dueDate: FilterDueDate;
  project: FilterProject;
}

export interface RawView {
  // Common
  id: string;
  name: string;
  description: string;
  icon: Icon;
  color: number;
  userIds: string[];

  //Default fields
  createdById: string;
  createdOn: Date;
  updatedById: string;
  updatedOn: Date;

  filters: ViewFilters;
}
export interface Icon {
  type: number;
  image: string;
}
export const VIEWS_FILTER_TYPE = {
  IS: 1,
  IS_NOT: 2,
  AFTER: 3,
  BEFORE: 4
};

export const VIEW_FILTER_LABELS = {
  [VIEWS_FILTER_TYPE.IS]: 'is',
  [VIEWS_FILTER_TYPE.IS_NOT]: 'is not',
  [VIEWS_FILTER_TYPE.AFTER]: 'after',
  [VIEWS_FILTER_TYPE.BEFORE]: 'before'
};

export const DEFAULT_VIEW_FILTERS = {
  status: {
    statuses: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  priority: {
    priorities: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  assign: {
    assignees: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  dueDate: {
    date: [],
    type: VIEWS_FILTER_TYPE.IS
  },
  project: {
    projects: [],
    type: VIEWS_FILTER_TYPE.IS
  }
};
